module.exports = "/assets/453aa1f1e0d29158e084440f2420d0f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/JE.png
// module id = 2631
// module chunks = 0